// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"551":"ea546d41","837":"fcc77b57","984":"154eddf4"}[chunkId] + ".chunk.css";
};